module.exports = __webpack_public_path__ + "static/media/IMG_20200208_161316.142144df.jpg";